import React, { createContext, useContext } from "react";
import { AuthMode, PluginConfig } from "../models/plugin-config";
import { useFonts } from "../hooks/useFonts";
import { useDirection } from "../hooks/useDirection";
type ConfigContextValue = {
	config: PluginConfig | null;
	authMode: AuthMode;
	setAuthMode: React.Dispatch<React.SetStateAction<AuthMode>>;
};

const ConfigContext = createContext<ConfigContextValue | undefined>(undefined);

export const ConfigProvider: React.FC<{
	config: PluginConfig | null;
	authMode: AuthMode;
	setAuthMode: React.Dispatch<React.SetStateAction<AuthMode>>;
	children: React.ReactNode;
}> = ({ config, authMode, setAuthMode, children }) => {
	useFonts(config);
	useDirection(config);

	return (
		<ConfigContext.Provider value={{ config, authMode, setAuthMode }}>
			{children}
		</ConfigContext.Provider>
	);
};

export function useConfigContext() {
	const context = useContext(ConfigContext);
	if (!context) {
		throw new Error(
			"useConfigContext must be used within a ConfigProvider",
		);
	}
	return context;
}
